import React from 'react';
import PatientFormTemplate from '../components/PatientFormTemplate';

export default function PatientADHDScalesChildhoodForm() {
    return (
        <PatientFormTemplate formTitle="Your Symptoms in Childhood" />
    );
}